import Vue from 'vue';

// A „Csak most” elrejtés böngészőszintű (sessionStorage); a „Többé ne” a tanár
// fiókjához megy (settings.helpVideoHidden), hogy más gépen se jelenjen meg újra.
// A session-jelzőt a widget és a profil menü is látja, ezért közös, reaktív állapot.
export const SESSION_KEY = 'xeropan.helpVideo.hidden';
export const SETTINGS_KEY = 'helpVideoHidden';

function session() {
  try {
    return window.sessionStorage;
  } catch (e) {
    return null;
  }
}

function readSession() {
  const s = session();
  try {
    return !!(s && s.getItem(SESSION_KEY));
  } catch (e) {
    return false;
  }
}

export const helpVideoState = Vue.observable({ sessionHidden: readSession() });

export function setSessionHidden(hidden) {
  const s = session();
  try {
    if (s && hidden) s.setItem(SESSION_KEY, '1');
    if (s && !hidden) s.removeItem(SESSION_KEY);
  } catch (e) {
    // Tiltott tároló: az állapot ettől még a munkamenet végéig érvényes.
  }
  helpVideoState.sessionHidden = hidden;
}

export const isHiddenForever = userSettings => !!(userSettings && userSettings[SETTINGS_KEY]);



// WEBPACK FOOTER //
// ./src/components/modules/helpVideo/helpVideoVisibility.js